import { StoreState } from '../store-interfaces';

export const selectSlackAccounts = (state: StoreState) => state.slack.accounts;

export const selectSlackAccountsId = (state: StoreState) =>
  state.slack.accountsId;

export const selectSlackChannels = (state: StoreState) =>
  state.slack.channelsById?.channels ?? [];
